import employeeStatusReason from '@/api/human-resource/employee-status-reason';

import { baseState, baseMutations } from '@/store/mixins';
import { isEmpty } from 'lodash';

export const state = {
    ...baseState
}

export const getters = {}

export const mutations = {
    ...baseMutations
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        )
        return employeeStatusReason.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return employeeStatusReason.store(data)
    },
    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await employeeStatusReason.find(id)
            context.commit('SET_EDIT_DATA', response.data)
        }
    },
    update(context, { id, data }) {
        return employeeStatusReason.update(id, data)
    },
    destroy(context, id) {
        return employeeStatusReason.destroy(id)
    },
    getFormViewData() {
        return employeeStatusReason.formModel()
    }
}
